<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col
        cols="12"
        md="6"
        offset-md="6"
        class="pa-2 d-flex align-center justify-end"
      >
        <v-btn icon class="mr-3" @click="toggleSearch = !toggleSearch">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
        <v-btn icon color="accent" class="mr-3" @click="getZones">
          <v-icon>mdi-reload</v-icon>
        </v-btn>
        <v-btn
          :ripple="false"
          depressed
          color="primary"
          @click="openDialog"
        >
          <v-icon class="mr-3">mdi-plus-circle</v-icon>
          {{ $t("actions.createZone") }}
        </v-btn>
      </v-col>
      <v-col v-if="toggleSearch" cols="12" class="pa-2 pt-0">
        <v-text-field
          v-model="search"
          :label="$t('actions.search')"
          hide-details
          width="100%"
        />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="pa-2 d-flex flex-column">
        <v-card height="100%" class="d-flex flex-column elevation-3 pa-2">
          <v-data-table
            :headers="headers"
            :items="data"
            :search="search"
            :custom-filter="zonesFilter"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            hide-default-footer
            @page-count="pageCount = $event"
          >
            <template v-slot:[`item.type`]="{ item }">
              <v-chip :color="zoneColor(item.type)">{{ item.type }}</v-chip>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn small icon>
                <v-icon small @click="alterAction('show', item.id)">
                  mdi-eye
                </v-icon>
              </v-btn>
              <template>
                <v-btn v-if="!item.isExternal" small icon>
                  <v-icon small @click="alterAction('edit', item.id)">
                    mdi-pencil
                  </v-icon>
                </v-btn>
                <v-btn v-if="!item.isExternal" small icon>
                  <v-icon small @click="alterAction('delete', item.id)">
                    mdi-delete
                  </v-icon>
                </v-btn>
              </template>
            </template>
          </v-data-table>
          <v-spacer />
          <div class="text-center ml-auto pt-2">
            <v-pagination v-model="page" circle :length="pageCount" />
          </div>
        </v-card>
      </v-col>
    </v-row>

    <zone-dialog
      v-model="object"
      :show-dialog="dialog"
      :readonly="!isEditting"
      @toggle-dialog="(state) => (dialog = state)"
      @set-readonly="(state) => (isEditting = state)"
    />
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import list from 'GraphQL/queries/zones/list.gql'
import deleteMutation from 'GraphQL/mutations/zones/delete.gql'
import importZones from '@/graphql/mutations/zones/import.gql'

import { Dialog as ZoneDialog } from 'Components/zones'

import { filters } from '@/mixins'

const dayjs = require('dayjs')
require('dayjs/locale/es')
dayjs.locale('es')

export default {
  components: {
    ZoneDialog
  },
  mixins: [filters],
  data () {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      isEditting: false,
      object: {},
      dialog: false,
      search: '',
      toggleSearch: false
    }
  },
  computed: {
    ...mapState(['isDark', 'zones', 'users', 'zones']),

    headers () {
      return [
        {
          text: this.$i18n.t('zones.name'),
          align: 'center',
          sortable: true,
          value: 'name'
        },
        { text: this.$i18n.t('zones.type.title'), value: 'type' },
        { text: '', value: 'actions', sortable: false, align: 'end' }
      ]
    },

    data () {
      return this.zones.list
    }
  },
  created () {
    this.object = Object.assign({}, this.$store.getters['zones/defaultObject'])
  },
  methods: {
    openDialog () {
      this.dialog = true
      this.isEditting = true
      this.object = Object.assign(
        {},
        this.$store.getters['zones/defaultObject']
      )
    },

    zoneColor (type) {
      let result = 'primary'
      switch (type) {
        case 'RESTRICTED':
          result = 'amber'
          break

        case 'DANGEROUS':
          result = 'red'
          break

        default:
          break
      }

      return result
    },

    evaluateResponse ({ status, errors, result, action }) {
      this.isLoading = false
      console.log(action)
      switch (status) {
        case 'OK':
          if (action === 'import') {
            this.$store.commit('toggleSnackbar', {
              color: 'success',
              message: this.$t('helpers.import.success')
            })
            this.$store.dispatch('zones/getList', true)
          } else if (action !== 'delete') {
            this.object = result[0]
            this.dialog = true
          } else {
            this.$store.dispatch('zones/getList', false)
          }
          break
        case 'UNPROCESSABLE':
          this.$store.commit('toggleSnackbar', {
            color: 'orange darken-2',
            message: this.$t('errors.invalidFields')
          })
          break
        case 'BADREQUEST':
          this.$store.commit('toggleSnackbar', {
            color: 'orange darken-2',
            message: this.$t('errors.invalidFields')
          })
          break
        case 'ACCESSDENIED':
          this.$store.commit('toggleSnackbar', {
            color: 'orange darken-2',
            message: this.$t('errors.accessdenied')
          })
          break
      }
    },
    getDetail (id, action) {
      console.log(id)
      this.$apollo
        .query({
          query: list,
          variables: {
            token: this.users.entity.token,
            id: id
          },
          fetchPolicy: 'no-cache'
        })
        .then((response) => {
          const { status, errors, result } = response.data.zones
          this.evaluateResponse({ status, errors, result, action })
        })
        .catch((err) => {
          console.log('Error handled', err)
          this.$store.commit('toggleSnackbar', {
            color: 'red darken-2',
            message: this.$t('helpers.errors.disaster')
          })
        })
    },

    deleteItem (id, action) {
      this.$apollo
        .mutate({
          mutation: deleteMutation,
          variables: {
            token: this.users.entity.token,
            ids: [id]
          },
          fetchPolicy: 'no-cache'
        })
        .then((response) => {
          const { status, errors, result } = response.data.deleteZones
          this.evaluateResponse({ status, errors, result, action })
        })
        .catch((err) => {
          console.log('Error handled', err)
          this.$store.commit('toggleSnackbar', {
            color: 'red darken-2',
            message: this.$t('helpers.errors.disaster')
          })
        })
    },

    alterAction (action, id) {
      if (action === 'show') {
        this.isEditting = false
        this.getDetail(id, action)
      } else if (action === 'edit') {
        this.isEditting = true
        this.getDetail(id, action)
      } else {
        this.deleteItem(id, action)
      }
    },

    getZones () {
      this.$apollo
        .mutate({
          mutation: importZones,
          variables: {
            token: this.users.entity.token
          },
          fetchPolicy: 'no-cache'
        })
        .then((response) => {
          const { status, errors } = response.data.importZones
          this.evaluateResponse({ status, errors, result: null, action: 'import' })
        })
        .catch((err) => {
          console.log('Error handled', err)
          this.$store.commit('toggleSnackbar', {
            color: 'red darken-2',
            message: this.$t('helpers.errors.disaster')
          })
        })
    }
  }
}
</script>
